import React from "react";
import { MODULES } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const PermissionsPicker = ({ value, onChange, testidPrefix = "perm" }) => {
  const toggle = (key) => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
  return (
    <div className="space-y-2" data-testid={`${testidPrefix}-picker`}>
      <div className="flex items-center justify-between">
        <Label className="text-xs text-muted-foreground">Modules this staff can access & see</Label>
        <div className="flex gap-1">
          <Button type="button" size="sm" variant="ghost" className="h-6 text-xs" onClick={() => onChange(MODULES.map((m) => m.key))} data-testid={`${testidPrefix}-all`}>All</Button>
          <Button type="button" size="sm" variant="ghost" className="h-6 text-xs" onClick={() => onChange([])} data-testid={`${testidPrefix}-none`}>None</Button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {MODULES.map((m) => (
          <label key={m.key} className="flex items-center gap-2 text-sm cursor-pointer rounded-md border px-2.5 py-1.5 hover:bg-muted/50">
            <Checkbox checked={value.includes(m.key)} onCheckedChange={() => toggle(m.key)} data-testid={`${testidPrefix}-${m.key}`} />
            <span>{m.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
